import { defineMessages } from 'react-intl-next';

export default defineMessages({
	allDay: {
		id: 'jsm.calendar.src.ui.calendar-provider.all-day-content.allDay',
		defaultMessage: 'All day',
		description: 'Text that implies an event will be a whole day',
	},
});
